/**
 * Spinner Component
 * Consistent animated loading spinner with size and color options
 */

import React from 'react';
import styles from './Spinner.module.css';

export interface SpinnerProps {
  /** Size variant */
  size?: 'sm' | 'md' | 'lg';
  /** Custom color (defaults to primary-500) */
  color?: string;
  /** Optional label text */
  label?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({
  size = 'md',
  color,
  label,
}) => {
  const sizeMap = {
    sm: 16,
    md: 24,
    lg: 32,
  };

  const spinnerSize = sizeMap[size];
  const spinnerStyle = color ? { borderTopColor: color } : {};

  return (
    <div className={styles.spinnerContainer}>
      <div
        className={`${styles.spinner} ${styles[size]}`}
        style={spinnerStyle}
        role="status"
        aria-label={label || 'Loading'}
      >
        <span className={styles.srOnly}>{label || 'Loading...'}</span>
      </div>
      {label && <span className={styles.label}>{label}</span>}
    </div>
  );
};

export default Spinner;
